import { useEffect, useState } from "react";
import { BuildJobInfo, JobType } from "../../../data/interfaces/jobmodels";
import { Box, Card, CardActionArea, CardContent, CardHeader, List, ListItem, Paper, Table, TableBody, TableCell, TableContainer, TableRow, Typography } from "@mui/material";
import jobService from "../../../data/api/job.service";
import { useNavigate } from "react-router-dom";

export default function ReleaseSummary(){
    const navigate=useNavigate();
    const [releasejobs, setReleaseJobs] = useState<BuildJobInfo[]>([]);
    useEffect(()=>{
        jobService.getJobs(true,JobType.Release,"5","3",null,false,5).then((response)=>{
            setReleaseJobs(response.data);
        })
    },[]);
    return(

        <Card  >
            <CardHeader  title="Last 5 Release Jobs"/>
            <CardContent>
            <TableContainer>
                    <Table>
                        <TableBody>
                        {releasejobs.map((job)=>{
                        return(
                            <TableRow key={job.Id}>
                                <TableCell>{job.ReleaseName}</TableCell>
                                    <TableCell>{job.Description}</TableCell>
                                    <TableCell>{job.CreatedDate}</TableCell>
                                    <TableCell>{job.CreatedUser}</TableCell>
                            </TableRow>
                        )
                    })}
                        </TableBody>
                    </Table>
                </TableContainer>
                
            </CardContent>
            <CardActionArea sx={{textAlign:'center',p:1,color:'primary.main'}} onClick={()=>navigate('/jobs')}>
                <Typography variant="body1">View More</Typography> 
            </CardActionArea>
        </Card>
    );
}